import { createContext, useContext, useEffect, useState } from "react";
import { VENDOR, VENDORS } from "..";

type Context = {
  getVendorTitle: () => string;
  getVendorSubtitle: () => string;
  getVendorLogo: () => string;
};

export const VendorContext = createContext<Context>({
  getVendorTitle: () => "",
  getVendorSubtitle: () => "",
  getVendorLogo: () => "",
});

export function useVendor() {
  return useContext(VendorContext);
}

export function VendorProvider({ children }: { children: React.ReactNode }) {
  const [data, setData] = useState<Context>({
    getVendorLogo: () => "",
    getVendorSubtitle: () => "",
    getVendorTitle: () => "",
  });

  const fetchVendor = async () => {
    if (VENDOR === VENDORS.PE) {
      const getVendorTitle = () => "Command Centre";
      const getVendorSubtitle = () => "Player Elite";
      const getVendorLogo = () => "/app_icon_black.png";
      setData({ getVendorLogo, getVendorSubtitle, getVendorTitle });
    }

    if (VENDOR === VENDORS.USA) {
      const getVendorTitle = () => "Command Centre";
      const getVendorSubtitle = () => "Player Elite";
      const getVendorLogo = () => "/app_icon_black.png";
      setData({ getVendorLogo, getVendorSubtitle, getVendorTitle });
    }

    if (VENDOR === VENDORS.ODYSSEY) {
      const getVendorTitle = () => "Command Centre";
      const getVendorSubtitle = () => "Powered by Odyssey";
      const getVendorLogo = () => "/nexus_logo.png";
      setData({ getVendorLogo, getVendorSubtitle, getVendorTitle });
    }
  };

  useEffect(() => {
    fetchVendor();
  }, []);

  const value: Context = data;

  return (
    <VendorContext.Provider value={value}>{children}</VendorContext.Provider>
  );
}
